import { useQueries, useQuery } from "@tanstack/react-query";

import { getRanaApiV1 } from "@nens/rana/api-v1";

type Permissions = {
  project_manage: boolean;
  project_write: boolean;
  project_read: boolean;
};

const getProjectPermissions = (projectId: string | undefined) => {
  return getRanaApiV1().getQueryOptions<Permissions>({
    queryKey: ["projects", projectId, "permissions"],
    queryFn: async () => {
      if (!projectId) throw Error("Never happens");

      return (await getRanaApiV1().ProjectsApi.projectPermissions({ projectId })) as Permissions;
    },
    enabled: !!projectId,
  });
};

export const useProjectPermissionsQuery = (projectId: string | undefined) => {
  return useQuery(getProjectPermissions(projectId));
};

export const useProjectPermissionsQueries = (projectIds: string[]) => {
  return useQueries({ queries: projectIds.map(getProjectPermissions) });
};
